module.exports = __webpack_public_path__ + "static/Olympo35-fcdfbad18c8509a0e346fb32927c1b83.mp4";